import { render, staticRenderFns } from "./DiamondKnowledge.vue?vue&type=template&id=365b1b56&scoped=true&"
import script from "./DiamondKnowledge.vue?vue&type=script&lang=js&"
export * from "./DiamondKnowledge.vue?vue&type=script&lang=js&"
import style0 from "./DiamondKnowledge.vue?vue&type=style&index=0&id=365b1b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365b1b56",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default,UiButton: require('/app/components/UI/UiButton.vue').default})
